<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success-bf tw-text-center tw-items-center tw-justify-center">
            <img src="~@/assets/img/icons/success.svg">
            <h2>Está a um passo de usufruir<br>
                da Black Friday Minisom</h2>
            <p>Brevemente irá ser contactado pela Minisom!</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccessBlackfriday',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';

.form-success-bf {
    @apply tw-flex tw-items-center tw-justify-center tw-flex-col;
    background-color: #fff !important;
    width: 320px;
    height: 473px;

    @screen lg {
        width: 100%;
        height: auto;
        border-radius: 20px;
    }

    >img {
        @apply tw-pointer-events-none;

        @screen lg {
            padding-top: 150px;
        }
    }

    h2 {
        margin: 20px auto;
        color: $main_color !important;
        text-align: center;
        font-weight: 700;
        font-size: 27px;
        line-height: 17px;

        @screen lg {
            font-size: 24px;
            line-height: 29px;
        }
    }

    p {
        @apply tw-mx-auto;
        margin-top: 10px;
        color: #000 !important;
        text-align: center;
        font-size: 14px;
        line-height: 17px;

        @screen lg {
            font-size: 20px;
            line-height: 35px;
            padding-bottom: 150px;
            max-width: 260px;
        }
    }
}

</style>